async function favourites() {
  // Function to get the favorite stores from local storage and log them to the console
  const logFavoriteStores = () => {
    console.log('Current Favourite Store:', localStorage.getItem('tg--webcheckin-fav'));
  };

  const allLocations = document.querySelectorAll("li.location");

  allLocations.forEach((location) => {
    // console.log("Location:", location)
    const favIcon = location.querySelector(".fav-location");
    const locationName = location.getAttribute("data-location");

    // Set active if favourite on first load
    const isFav = localStorage.getItem('tg--webcheckin-fav') === locationName;
    if (isFav) document.querySelectorAll(`.location[data-location="${locationName}"]`).forEach(e => e.classList.add("is-fav"));

    // Function to toggle the favorite status
    const toggleFavorite = () => {
      // Recheck Favourite on toggle
      const isFav = localStorage.getItem('tg--webcheckin-fav') === locationName;

      // Remove "is-fav" class from all locations
      document.querySelectorAll('.is-fav').forEach(elem => elem.classList.remove('is-fav'))

      // Toggle Favourite
      if (!isFav) {
        localStorage.setItem('tg--webcheckin-fav', locationName);
        document.querySelectorAll(`.location[data-location="${locationName}"]`).forEach(e => e.classList.add("is-fav"));
        // checkAndFetchLocation();
      } else {
        localStorage.setItem('tg--webcheckin-fav', undefined);
        document.querySelectorAll(`.location[data-location="${locationName}"]`).forEach(e => e.classList.remove("is-fav"));
      }
    };

    // Add a click event listener to the favorite button
    favIcon.addEventListener("click", () => {
      toggleFavorite();
      logFavoriteStores();
    });
  });

  // Call the function to log favorite stores initially
  logFavoriteStores();
}


///////////////////
// Nav Drawer
//////////////////
async function navDrawer() {
  // const buttons = document.querySelectorAll('[data-nav-drawer]');
  const buttons = document.querySelectorAll('.has-drawer-nav summary');
  const navDrawer = document.getElementById('nav-drawer');
  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      if (theme.mediaMatches.md) {
        navDrawer.open(button);
      }
    });
  });
  // Select the element you want to move and the target container
  const nestedNav = document.querySelector('.has-drawer-nav .nested_nav ul');
  const drawerContent = document.querySelector('#nav-drawer .drawer__content');


  // Appends drawer nav to body (once) before open, to avoid z-index issues with overlay and header.
  if (navDrawer.parentElement !== document.body) {
    document.body.appendChild(navDrawer);
  }

  // Somewhere in your theme initialization
  theme.navDrawerIsOpen = false;

  navDrawer.addEventListener('on:nav-drawer:before-open', (event) => {
    // console.log('Drawer opening!', event);
    theme.navDrawerIsOpen = true;
  });
  navDrawer.addEventListener('on:nav-drawer:after-open', (event) => {
    // console.log('Drawer is open!', event);
  });
  navDrawer.addEventListener('on:nav-drawer:after-close', (event) => {
    // console.log('Drawer closed!', event);
    theme.navDrawerIsOpen = false;
  });

  // Attach a single event listener to the nav-drawer container
  navDrawer.addEventListener('click', (event) => {
    // Scroll all ul elements inside navDrawer to top
    navDrawer.querySelectorAll('ul').forEach(ul => {
      ul.scrollTo({ top: 0, behavior: 'smooth' });
    });

    const target = event.target;

    if (target.matches('.nav-back')) {
      handleBackClick(target);
    } else if (target.matches('.nested-nav')) {
      handleNavItemClick(target);
    }
  });
}

function handleNavItemClick(navItem) {
  const li = navItem.closest('li');
  if (!li) return;
  // Using :scope > ul ensures we only get the direct child menu
  const childMenu = li.querySelector(':scope > ul');
  // const parentUl = navItem.closest('ul');
  // parentUl.scrollTop = 0;
  if (childMenu && childMenu.getAttribute('data-visible') === 'false') {
    childMenu.setAttribute('data-visible', 'true');
    childMenu.setAttribute('open', '');
  }
}

function handleBackClick(backButton) {
  // The parent of the back button is the menu <ul> that we want to close.
  const parentMenu = backButton.parentElement;
  if (parentMenu && parentMenu.hasAttribute('data-visible')) {
    // Close any open child menus within the parent menu.
    const openSubMenus = parentMenu.querySelectorAll('ul[open]');
    openSubMenus.forEach(submenu => {
      submenu.setAttribute('data-visible', 'false');
      submenu.removeAttribute('open');
    });
    // Now close the parent menu itself.
    parentMenu.setAttribute('data-visible', 'false');
    parentMenu.removeAttribute('open');
  }
}

document.addEventListener("DOMContentLoaded", function () {
  navDrawer();
  favourites();
});